import Svg, { Line } from 'react-native-svg';

export const PreviewGrid = ({ strokeColor = '#000000', strokeWidth = 1, style = {} }) => {
  return (
    <Svg width="100%" height="100%" style={style} preserveAspectRatio="none" viewBox="0 0 100 100">
      <Line
        x1="33.33"
        y1="0"
        x2="33.33"
        y2="100"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      <Line
        x1="66.66"
        y1="0"
        x2="66.66"
        y2="100"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      <Line
        x1="0"
        y1="33.33"
        x2="100"
        y2="33.33"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      <Line
        x1="0"
        y1="66.66"
        x2="100"
        y2="66.66"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
    </Svg>
  );
};
